import React from 'react';
export function Footer() {
  return <footer className="bg-white py-8 border-t border-gray-100" data-id="element-124">
      <div className="container mx-auto px-5 text-center" data-id="element-125">
        <div className="font-display font-bold text-2xl text-gray-800 mb-4" data-id="element-126">
          Yoga Kids <span className="text-pastel-lavender-dark" data-id="element-127">ELITE</span>
        </div>

        <div className="flex justify-center gap-6 text-sm text-gray-500 mb-4" data-id="element-128">
          <a href="#" className="hover:text-pastel-lavender-dark transition-colors" data-id="element-129">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-pastel-lavender-dark transition-colors" data-id="element-130">
            Privacidad
          </a>
          <a href="#" className="hover:text-pastel-lavender-dark transition-colors" data-id="element-131">
            Contacto
          </a>
        </div>

        <p className="text-xs text-gray-400" data-id="element-132">
          © {new Date().getFullYear()} Yoga Kids ELITE. Todos los derechos
          reservados.
          <br data-id="element-133" />
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}